import codeApiFactory from "./code/code.api";
import searchApiFactory from "./search/search.api";
import favouriteUrlApiFactory from "./favourite-url/favourite-url.api";
import reportApiFactory from "./report/report.api";
import practiceApiFactory from "./practice/practice.api";
import socialApiFactory from "./social/social.api";
import urlApiFactory from "./url/url.api";
import domainApiFactory from "./domain/domain.api";
import productApiFactory from "./product/product.api";
import transactionApiFactory from "./transaction/transaction.api";
import billingApiFactory from "./billing/billing.api";
import notificationApiFactory from "./notification/notification.api";
import takedownApiFactory from "./takedown/takedown.api";
import actAsApiFactory from "./act-as/act-as.api";
import clientSearchesApiFactory from "./client-searches/client-searches.api";
import statsApiFactory from "./stats/stats.api";
import { codeHttpClient } from "../http/clients/code/code.http";

export { codeHttpClient };

export const codeApi = codeApiFactory({
  codeHttpClient,
});

export const notificationApi = notificationApiFactory({
  codeHttpClient,
});

export const takedownApi = takedownApiFactory({
  codeHttpClient,
});

export const actAsApi = actAsApiFactory({
  codeHttpClient,
});

export const clientSearchesApi = clientSearchesApiFactory({
  codeHttpClient,
});

export const statsApi = statsApiFactory({
  codeHttpClient,
});

export const researchApi = searchApiFactory({
  codeHttpClient,
});

export const favouriteUrlApi = favouriteUrlApiFactory({
  codeHttpClient,
});

export const reportApi = reportApiFactory({
  codeHttpClient,
});

export const practiceApi = practiceApiFactory({
  codeHttpClient,
});

export const socialApi = socialApiFactory({
  codeHttpClient,
});

export const urlApi = urlApiFactory({
  codeHttpClient,
});

export const domainApi = domainApiFactory({
  codeHttpClient,
});

export const productApi = productApiFactory({
  codeHttpClient,
});

export const transactionApi = transactionApiFactory({
  codeHttpClient,
});

export const billingApi = billingApiFactory({
  codeHttpClient,
});